import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNDlodGNnMCB7CiAgZGlzcGxheTogY29udGVudHM7Cn0';
export var unstyledStyle = '_149htcg0';